import React from "react";
import "./header.css";
import { useNavigate } from "react-router-dom";
// function goBack(){
//   const navigator = useNavigate();
// }
// 创建一个 JSX 元素
export default function Header(props) {
  const navigator = useNavigate();
  function goBack() {
    // window.history.back();
    navigator(-1);
  }

  return (
    <div className="header">
      <div
        style={{ textAlign: "left", paddingLeft: props.icon ? "20px" : "10px"}}
        onClick={props.icon ? goBack : () => {}}
      >
        {props.boldTitle && <span style={{fontWeight:600}}>{props.boldTitle}</span>}{props.title}
      </div>
      {props.icon && (
        <img
          className="return-img"
          onClick={goBack}
          src="/image/return.png"
          alt=""
        />
      )}
      {props.date && <div style={{paddingRight:"10px",fontSize:"0.8rem"}}>日期：{props.date}</div>}
      {props.time && <div style={{paddingRight:"10px",fontSize:"0.8rem"}}>{props.time}</div>}
    </div>
  );
}
